import { useQuery } from '@tanstack/react-query';
import { notification } from 'antd';
import { AxiosResponse } from 'axios';

import { ListShareholderWithGroupSchema } from '@/features/irm/entities/participants';
import { apiV1 } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

export type ShareholderWithGroupResponse = {
  shareholders: ListShareholderWithGroupSchema[];
  totalItems: number;
  totalPages: number;
};

export const getShareholderWithGroup = (
  filters: ShareholderWithGroupFilters,
): Promise<AxiosResponse<ShareholderWithGroupResponse>> => {
  return apiV1.get(`/v1/irm/shareholder/with-subgroup`, {
    params: filters,
  });
};

type QueryFnType = typeof getShareholderWithGroup;

export type ShareholderWithGroupFilters = {
  search?: string;
  page?: number;
  size?: number;
  event_id?: string;
  alert_id?: string;
};

type UseShareholderWithGroupOptions = {
  companyId: string;
  filters?: ShareholderWithGroupFilters;
  config?: QueryConfig<QueryFnType>;
};

export const useShareholderWithGroup = ({
  companyId,
  config,
  filters,
}: UseShareholderWithGroupOptions) => {
  const cleanedFilters = {
    ...filters,
    search: filters?.search?.trim() ? filters.search : undefined,
  };

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    onError: () => {
      notification.error({ message: `Não foi possível buscar os shareholders relevantes.` });
    },
    ...config,
    queryKey: [`shareholder-with-group`, companyId, cleanedFilters], // 🔹 Agora atualiza quando os filtros mudam!
    queryFn: () => getShareholderWithGroup(cleanedFilters),
    // keepPreviousData: true, // 🔹 Mantém os dados anteriores enquanto carrega a nova página/pesquisa
  });
};
